import { render, staticRenderFns } from "./PacketList.vue?vue&type=template&id=bf129b86&scoped=true&"
import script from "./PacketList.vue?vue&type=script&lang=js&"
export * from "./PacketList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf129b86",
  null
  
)

export default component.exports